import { PrivacyPage } from '@/app/pages/PrivacyPage';

export function ResponsivePrivacyPage() {
  return <PrivacyPage />;
}
